import { Empty } from "antd";
import { useTranslation } from "react-i18next";

const EmptyTickets = () => {
  const { t } = useTranslation("helpCenter");
  return (
    <div className="empty-wrapper">
      <Empty
        description={
          <>
            <strong>{t("empty.title")}</strong>
            <p>{t("empty.description")}</p>
          </>
        }
      />
    </div>
  );
};

export default EmptyTickets;
